import React, { useState, useEffect } from 'react';

const Preloader = () => {
  const loader = (
    iconUrl = '',
    text = 'Загружаем лучшие места...',
    style = 'is-loading',
  ) => {
    return (
      <div
        className={`scheme-popup__scheme scheme-box ${style}`}
        style={{ background: 'none' }}
      >
        {iconUrl && <img src={iconUrl} alt="Загрузка..."></img>}
        {text}
      </div>
    );
  };

  const [preloader, setPreloader] = useState(loader());

  useEffect(() => {
    const timeout1 = setTimeout(
      () =>
        setPreloader(
          loader(
            '/local/templates/comfortkino/static/img/pop-corn.gif',
            'Жарим поп-корн, наливаем газировку...',
            'is-loading-icon',
          ),
        ),
      4000,
    );

    const timeout2 = setTimeout(
      () =>
        setPreloader(
          loader(
            '/local/templates/comfortkino/static/img/anger.gif',
            'Да что ж так долго-то...',
            'is-loading-icon',
          ),
        ),
      8000,
    );
    return () => {
      clearTimeout(timeout1);
      clearTimeout(timeout2);
    };
  }, []);

  return (
    <div className="scheme-popup">
      <img
        className="scheme-popup__preloader-img"
        src="/local/templates/comfortkino/static/img/loader_preview.svg"
        // src="/src/img/loader_preview.svg"
        alt="Loader preview"
      />
      <button className="scheme-popup__close" type="button">
        <svg viewBox="0 0 18 18" width="18" height="18">
          <path d="M15.5 17.6l-6.5-6.5-6.5 6.5c-.6.6-1.5.6-2.1 0-.6-.6-.6-1.5 0-2.1l6.5-6.5-6.5-6.5c-.6-.6-.6-1.5 0-2.1.6-.6 1.5-.6 2.1 0l6.5 6.5 6.5-6.5c.6-.6 1.5-.6 2.1 0 .6.6.6 1.5 0 2.1l-6.5 6.5 6.5 6.5c.6.6.6 1.5 0 2.1-.3.3-.6.4-1 .4s-.8-.2-1.1-.4z" />
        </svg>
      </button>
      <div className="scheme-popup__timetable"></div>
      <div className="scheme-popup__scheme scheme-box">{preloader}</div>
      <div className="scheme-popup__content">
        <div className="checkout">
          <div className="checkout-result">
            <div className="checkout-result__note"></div>
            <div className="checkout-result__wrapper">
              <span className="hint__tickets"></span>
              <div className="wrap">
                <div className="button btn btn--accent btn--disable">
                  Купить билет
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Preloader;
